import { useDispatch, useSelector } from 'react-redux';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { useEffect } from 'react';
import {
  emailSendModalActions,
  emailSendModalAsyncActions,
  SendEmailStep,
} from '@/ModalWindows/EmailSendModal/services/reducer';
import { WINDOW_MODAL_TYPE } from '@/ModalWindows/services';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { orderTableRowUtils } from '@/Types/OrderTableRowUtils';

export function useEmailSendModalOptions() {
  const dispatch: AppDispatch = useDispatch();

  const currentStep = useSelector(emailSendModalSelectors.currentStep);
  const selectedSale = useSelector(salesPageSelectors.selectedSale);
  const documentType = useSelector(emailSendModalSelectors.documentType);

  useEffect(() => {
    const documentPrintType = WINDOW_MODAL_TYPE[location.pathname];
    dispatch(emailSendModalAsyncActions.getEmailTemplates(documentPrintType));
  }, []);

  useEffect(() => {
    if (documentType && selectedSale) {
      const documentNumbers = orderTableRowUtils.getDocumentNumbersByType(documentType, selectedSale);
      dispatch(emailSendModalActions.setSelectedTypeNumbers(documentNumbers));

      if (documentNumbers.length == 0) {
        dispatch(emailSendModalActions.setSendEmailStep(SendEmailStep.CreateDocument));
      } else if (documentNumbers.length == 1) {
        dispatch(emailSendModalActions.setSendEmailStep(SendEmailStep.SingleDocumentPrint));
      } else {
        dispatch(emailSendModalActions.setSendEmailStep(SendEmailStep.SelectDocumentNumber));
      }
    } else {
      dispatch(emailSendModalActions.setSendEmailStep(SendEmailStep.SelectTemplate));
    }

    return () => {
      dispatch(emailSendModalActions.resetState());
    };
  }, []);

  return {
    currentStep,
  };
}
